interface TaskType {
    type: string;
    description: string;
}

export const ChaseImmunisationBloodTestResultsTask: TaskType = {
    type: "ChaseImmunisationBloodTestResultsTask",
    description: "Chase Immunisation blood test result"
};

export const ReviewImmunisationBloodTestResultTask: TaskType = {
    type: "ReviewImmunisationBloodTestResultTask",
    description: "Review immunisation blood test results"
};

export const ImmunisationClearTask: TaskType = {
    type: "ImmunisationClearanceTask",
    description: "Immunisation Clearance Confirmed"
};

export const ReviewPpqDeclaration: TaskType = {
    type: "ReviewPpqDeclarationTask",
    description: "Review PPQ Declaration"
};
